import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const VISITOR_KEY = "ae_visitor_id";

function getVisitorId() {
  try {
    let v = localStorage.getItem(VISITOR_KEY);
    if (!v) {
      v = "v_" + Math.random().toString(36).substring(2) + Date.now().toString(36);
      localStorage.setItem(VISITOR_KEY, v);
    }
    return v;
  } catch { return null; }
}

export function useVisitorTracking() {
  const location = useLocation();
  useEffect(() => {
    // Skip admin routes
    if (location.pathname.startsWith("/atelier-admin")) return;
    const visitor_id = getVisitorId();
    api.post("/track/event", {
      type: "page_view",
      path: location.pathname,
      referrer: document.referrer || null,
      visitor_id,
    }).catch(() => {});
  }, [location.pathname]);
}

export function trackProductView(productId) {
  const visitor_id = getVisitorId();
  api.post("/track/event", {
    type: "product_view",
    product_id: productId,
    visitor_id,
  }).catch(() => {});
}
